export enum CloudProvider {
  GCP = "gcp",
  ALICLOUD = "alicloud",
  FIREBASE = "firebase",
}
